"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HighlightQueryInText = void 0;
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
function HighlightQueryInText(_a) {
    var text = _a.text, query = _a.query;
    if (!query)
        return react_1.default.createElement("span", null, text);
    var equalisedText = text.toLowerCase();
    var equalisedQuery = query === null || query === void 0 ? void 0 : query.toLowerCase();
    var pattern = new RegExp(escapeRegex(equalisedQuery), 'gi');
    // if no match return original text
    if (!pattern.test(text))
        return react_1.default.createElement("i", null, text);
    var updatedAddress = text.replace(pattern, function (match) {
        return "<b>" + match + "</b>";
    });
    return (react_1.default.createElement(StyledHighlightedText, { "data-testid": equalisedText.split(' ').join('-') }, html_react_parser_1.default(updatedAddress)));
}
exports.HighlightQueryInText = HighlightQueryInText;
var StyledHighlightedText = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  b {\n    font-weight: 600;\n  }\n"], ["\n  b {\n    font-weight: 600;\n  }\n"])));
function escapeRegex(regexString) {
    return regexString.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
}
var templateObject_1;
